import React from 'react';
import { Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { darken } from '@gamiphy/utils/color';
import { useTheme } from '@mui/material/styles';
import Button from './components/Button';
import Tab from './components/Tab';
import { useTabs } from './hooks';

const BarContent: React.FC = observer(() => {
  const tabs = useTabs();
  const theme = useTheme();
  const borderColor = theme ? darken(theme.palette.primary.main, 35) : undefined;

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: () => theme.palette.primary.main,
        minHeight: 'max-content',
        maxHeight: '100%',
        width: '100%',
        position: 'relative',
        borderRadius: '20px',
        border: 'solid 1px',
        borderColor,
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        direction="column"
        wrap="nowrap"
        spacing={1}
        sx={{
          height: '100%',
          p: () => theme.spacing(1),
          transition: 'all 1s ease-in-out',
        }}
      >
        <Grid>
          <Button />
        </Grid>
        {tabs.map((tab) => (
          <Grid key={tab.title} sx={{ transition: 'all 1s ease-in-out 1s' }}>
            <Tab tabInfo={tab} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
});

export default BarContent;
